export default {
    login: { method: 'post', url: 'auth/login' },
    forgotPass: { method: 'post', url: 'auth/esqueci-senha' },
};